/*
 * Get-towns.ts
 * Description: Includes function for sending a request
 * to get all towns from the API
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';

/**
 * Getting a list of all towns
 *
 * @param {String} ekatte - ekatte town number
 * @return {Object} Promise - a list of all towns
 */
export function getTowns(ekatte: string) {
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        Axios({
            url: APIURL + 'towns',
            method: 'get',
            params: {
                province: ekatte.slice(0, 3),
                municipality: ekatte,
            },
        }).then((response) => {
            const towns = [];
            // Creating a list suitable to be displayed in a select list
            for (const town of response.data.data) {
                towns.push({
                    value: town.attributes.ekatte,
                    text: town.attributes.name,
                });
            }
            resolve(towns);
        }).catch(() => {
            reject();
        });
    });
}
